import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const { pathname } = useLocation();

  const navLinks = [
    { label: "Home", href: "/" },
    { label: "Mutual Funds", href: "/mutual-funds" },
    { label: "Insurance", href: "/insurance" },
    { label: "Contact", href: "/contact" },
  ];

  // Scroll listener
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 60) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isHome = pathname === "/";

  return (
    <header
      className={`
    fixed top-0 z-50 w-full
    transition-all duration-500 ease-in-out
    ${
      isHome && !scrolled
        ? "bg-transparent"
        : "bg-black-dark-100/90 backdrop-blur-md shadow-lg"
    }
  `}
    >
      <nav className="flex justify-between items-center max-container padding-x py-5 transition-all duration-500">
        {/* Logo */}
        <Link to="/">
          <img
            src={process.env.REACT_APP_LOGO}
            alt="TradeTact"
            className="h-8 w-auto"
          />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-12">
          <ul className="flex items-center gap-10">
            {navLinks.map((item) => {
              const isActive = pathname === item.href;
              return (
                <li key={item.label}>
                  <Link
                    to={item.href}
                    className={`transition ${
                      isActive
                        ? "text-white border-b-2 border-primary1 pb-1"
                        : "text-primary1 hover:text-white"
                    }`}
                  >
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>

          {/* CTA */}
          <Link
            to="/open-account"
            className="bg-primary1 text-white px-5 py-2 rounded-xl shadow hover:opacity-90 transition"
          >
            Open Account
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      {/* Mobile Dropdown */}
      {isMenuOpen && (
        <div className="md:hidden bg-black-dark-100 w-full px-6 py-6 shadow-lg">
          <ul className="flex flex-col gap-6">
            {navLinks.map((item) => {
              const isActive = pathname === item.href;
              return (
                <li key={item.label}>
                  <Link
                    to={item.href}
                    className={`text-lg ${
                      isActive ? "text-primary1 font-semibold" : "text-white"
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                </li>
              );
            })}

            <Link
              to="/open-account"
              className="bg-primary1 text-white px-5 py-2 rounded-xl shadow hover:opacity-90 transition"
            >
              Open Account
            </Link>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Nav;
